<template>
  <section v-loading="loading" class="page-container">
    <div class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-select v-model="filters.dateType" placeholder="按">
            <el-option :value="0" label="按天统计" />
            <el-option :value="1" label="按周统计" />
            <el-option :value="2" label="按月统计" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="filters.timeRange"
            type="daterange"
            value-format="timestamp"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div>
      <div ref="myChart" style="width: 100%; height: 700px"></div>

      <table v-if="rows && rows.length" class="chart-table">
        <tr v-for="(cols, i) in rows" :key="i">
          <td v-for="(col, j) in cols" :key="j">{{ col }}</td>
        </tr>
      </table>
    </div>
  </section>
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    load: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      filters: {
        dateType: 0,
        timeRange: [new Date().getTime() - 86400000 * 90, new Date().getTime()],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      data: null,
    };
  },
  computed: {
    rows() {
      if (!this.data) {
        return [];
      }
      var rows = [];

      // header
      var headerCols = ["日期"];
      for (let i = 0; i < this.data.lines.length; i++) {
        headerCols.push(this.data.lines[i].name);
      }
      rows.push(headerCols);

      // data rows
      for (let i = 0; i < this.data.times.length; i++) {
        var cols = [];
        cols.push(this.data.times[i]);

        for (let j = 0; j < this.data.lines.length; j++) {
          const count = this.data.lines[j].counts[i];
          cols.push(count);
        }

        rows.push(cols);
      }

      return rows;
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        this.data = await this.load(this.filters);
        this.draw(this.data);
      } catch (e) {
        this.$message.error(e.message || e);
      } finally {
        this.loading = false;
      }
    },
    draw(data) {
      const myChart = echarts.init(this.$refs.myChart);

      let xs = [];
      const names = [];
      const series = [];
      if (data) {
        xs = data.times;
        if (data.lines && data.lines.length) {
          for (let i = 0; i < data.lines.length; i++) {
            names.push(data.lines[i].name);
            series.push({
              name: data.lines[i].name,
              data: data.lines[i].counts,
              type: "line",
              stack: "Total",
              smooth: true,
            });
          }
        }
      }

      myChart.setOption({
        // title: { text: "每日发帖数量" },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: names,
        },
        xAxis: {
          type: "category",
          data: xs,
        },
        yAxis: {
          type: "value",
        },
        series: series,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  tr {
    border: 1px red solid;
    font-size: 16px;
    background-color: #fafafa;

    &:first-child {
      font-size: 16px;
      font-weight: 900;
      background-color: #666666;

      td {
        background-color: #00d1b2;
        color: #fff;
      }
    }
    td {
      text-align: center;
      display: table-cell;
      padding: 8px;
      border: 1px solid #f5f5f5;
      background-color: #ffffff;

      &:first-child {
        width: 150px;
      }
    }
  }
}
</style>
